export const BUCKETS = {
  AssessmentRequestBrandingLogo: 'assessment_request_branding_logo'
};
